import { scriptAPI } from 'apis/story/scriptAPI';
import { DebounceInput } from 'react-debounce-input';
import styled from 'styled-components';
import { getEnvVariable } from 'utils/helper/lib';
import { theme } from 'utils/style/theme';

interface ScriptValidation {
  rownum: number; // 행번호
  validation: string; // 경고 문구
}

interface ScriptImage {
  image_name: string;
  image_type: string;
}

interface ScriptStandard {
  inEffect: [];
  outEffect: [];
  speaker: [];
  motion: [];
  emoticon: [];
  minicut: []; // 미니컷
  background: ScriptImage[]; // 배경 이미지
  illust: []; // 이미지 일러스트
}

let scriptStandard: ScriptStandard;

// * 배경 이미지 존재 유무
const checkBackgroundExists = (__name: string): boolean => {
  if (!scriptStandard.background) return false;

  const result = scriptStandard.background.filter(
    (item) => item.image_name && item.image_name == __name,
  );

  return result.length > 0;
};

// 헬퍼에게 스크립트 기준정보 전달.
export const SetScriptStandard = (__standard) => {
  scriptStandard = __standard.current;

  console.log(`SetScriptStandard : `, scriptStandard);
};

// * 스크립트 유효성 체크!
export const checkScriptValidation = (scriptData: Array<any>) => {
  console.log(`checkScriptValidation start : `, scriptData.length);

  let rowIndex = 0;
  const validationResult: ScriptValidation[] = [];

  for (let i = 0; i < scriptData.length; i++) {
    const sr = scriptData[i];

    // 말풍선 범위 체크
    if (sr.bubble_pos && sr.bubble_pos != '' && !Number.isNaN(sr.bubble_pos)) {
      if (sr.bubble_pos > 9 || sr.bubble_pos < 0) {
        const result: ScriptValidation = {
          rownum: rowIndex + 1,
          validation: '말풍선 위치의 범위를 벗어났습니다. <유효값 : 1~9>',
        };

        validationResult.push(result);
      }
    }

    if (sr.template == '배경' && !checkBackgroundExists(sr.script_data)) {
      const result: ScriptValidation = {
        rownum: rowIndex + 1,
        validation: `배경 : 등록되지 않은 배경 이미지입니다. [${sr.script_data}]`,
      };

      validationResult.push(result);
    }
    rowIndex++;
  } // ? end for

  return validationResult;
}; // ? END validateScript (스크립트 유효성 체크 )

// * 스크립트 읽어오기
export const fetchScriptData = async (
  project_id: number,
  episode_id: number,
  lang: string,
) => {
  const scripts = await scriptAPI.getScript(project_id, episode_id, lang);

  if (!scripts) return null;

  // 숫자타입 컬럼에 대해서 string 변경처리.
  scripts.forEach((scriptRow) => {
    if (!scriptRow.scene_id) {
      scriptRow.scene_id = '';
    }
    scriptRow.scene_id = scriptRow.scene_id.toString();

    if (!scriptRow.bubble_size) {
      scriptRow.bubble_size = '';
    }
    scriptRow.bubble_size = scriptRow.bubble_size.toString();

    if (!scriptRow.bubble_pos) {
      scriptRow.bubble_pos = '';
    }
    scriptRow.bubble_pos = scriptRow.bubble_pos.toString();

    // if (!scriptRow.bubble_size) {
    //   scriptRow.bubble_size = '';
    // }
    // scriptRow.bubble_size = scriptRow.bubble_size.toString();
  });

  return scripts;
};

export const sheetLicense = getEnvVariable('REACT_APP_SHEET_LICENSE');

export const sheetColumns = [
  {
    type: 'text',
    name: 'scene_id',
    title: '사건 ID',
    width: 74,
    // autoCasting: true,
  },
  {
    type: 'text',
    name: 'template',
    title: '템플릿',
    width: 110,
    // readonly: true,
  },
  { type: 'text', name: 'speaker', title: '화자', width: 75 },
  {
    type: 'text',
    name: 'script_data',
    title: '데이터',
    width: 380,
    autoCasting: false,
  },
  {
    type: 'text',
    name: 'target_scene_id',
    title: '사건이동',
    width: 90,
    autoCasting: true,
  },
  { type: 'text', name: 'requisite', title: '조건', width: 80 },
  {
    type: 'text',
    name: 'character_expression',
    title: '캐릭터 모션',
    width: 110,
  },
  {
    type: 'text',
    name: 'emoticon_expression',
    title: '이모티콘',
    width: 110,
  },
  {
    type: 'text',
    // mask: '0', //숫자만 입력 가능
    name: 'bubble_size',
    title: '말풍선\n크기',

    width: 55,
  },
  {
    type: 'text',
    // mask: '#', //숫자만 입력 가능
    name: 'bubble_pos',
    title: '말풍선\n위치',

    width: 55,
  },
  {
    type: 'text',
    name: 'control',
    title: '제어',
    autoCasting: false,
    width: 100,
  },
  {
    type: 'text',
    name: 'voice',
    title: '음성',
    autoCasting: false,
    width: 100,
  },
  {
    type: 'text',
    name: 'sound_effect',
    title: '효과음',
    autoCasting: false,
    width: 100,
  },
  {
    type: 'text',
    name: 'in_effect',
    title: '등장\n효과',
    autoCasting: false,
    width: 80,
  },
  {
    type: 'text',
    name: 'out_effect',
    title: '퇴장\n효과',
    autoCasting: false,
    width: 80,
  },
  {
    type: 'number',
    // mask: '0', //숫자만 입력 가능
    name: 'autoplay_row',
    title: '자동\n진행',
    width: 50,
  },
  { type: 'text', name: 'dev_comment', title: '메모', width: 120 },
  {
    type: 'hidden',
    name: 'project_id',
    title: '프로젝트 ID',
    width: 100,
    readOnly: true,
  },
  {
    type: 'hidden',
    name: 'episode_id',
    title: '에피소드 ID',
    width: 100,
    readOnly: true,
  },
  {
    type: 'hidden',
    name: 'selection_group',
    title: '선택지 그룹',
    width: 100,
    readOnly: true,
  },
  {
    type: 'hidden',
    name: 'selection_no',
    title: '선택지 번호',
    width: 100,
    readOnly: true,
  },
];

export const DebounceInputWrapper = styled(DebounceInput).attrs(
  (props: { disabled: boolean }) => props,
)`
  border: 1px solid ${theme.colors.gray_6};
  padding: 8px 45px !important;
  border-radius: 6px;
  height: 100%;
  &:hover,
  &:focus {
    border: 1px solid
      ${(props) =>
        props.disabled ? theme.colors.gray_6 : theme.colors.blue_focus};
  }
`;
